import { FC, useState } from 'react';

import classNames from 'classnames';

import { useMediaQuery } from 'hooks';
import { IconStarFilled } from 'icons';

import { Carousel } from '../carousel/Carousel';
import styles from './UserComments.module.css';

type Comment = {
  title: string;
  text: string;
  value?: number;
};

type UserCommentCardProps = {
  comment: Comment;
  vertical: boolean;
};

type UserCommentListProps = {
  comments: Comment[];
};

type UserCommentCardType = FC<UserCommentCardProps>;

type UserCommentListType = FC<UserCommentListProps> & {
  Comment: UserCommentCardType;
};

const UserCommentCard: UserCommentCardType = props => {
  const { comment, vertical } = props;

  const starsRowIcon = Array.from(Array(comment.value), (_, index) => (
    <IconStarFilled
      className={styles.star}
      key={`star_${comment.title}_${index}`}
    />
  ));

  return (
    <div
      className={classNames(
        styles.comment_card,
        vertical && styles.comment_card_vertical,
      )}
    >
      <div>{starsRowIcon}</div>
      <div>{comment.title}</div>
      <div>{comment.text}</div>
    </div>
  );
};

const splitEvery = (chunkSize: number, arr: Comment[]) => {
  const res = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    const chunk = arr.slice(i, i + chunkSize);
    res.push(chunk);
  }
  return res;
};

export const UserCommentList: UserCommentListType = props => {
  const { comments } = props;

  const [progress, setProgress] = useState(0);

  const isMobile = useMediaQuery('(max-width: 905px)');

  const renderMobileView = () => {
    const chunks = splitEvery(3, comments);

    return chunks.map((c, i) => {
      return (
        <Carousel.Slide
          className={styles.comment_group}
          key={`comment_chunk_${i}`}
        >
          {c.map((comment, index) => (
            <UserCommentList.Comment
              comment={comment}
              vertical
              key={`comment_chunk_${i}_${index}`}
            />
          ))}
        </Carousel.Slide>
      );
    });
  };

  const renderDesktopView = () => {
    return comments.map((comment, i) => (
      <Carousel.Slide className={styles.slider} key={`comment_${i}`}>
        <UserCommentList.Comment comment={comment} vertical={false} />
      </Carousel.Slide>
    ));
  };

  if (isMobile == null) return null;

  return (
    <>
      <Carousel onChangeScrollProgress={setProgress}>
        <Carousel.Container>
          {isMobile ? renderMobileView() : renderDesktopView()}
        </Carousel.Container>
      </Carousel>
      <Carousel.Progress progress={progress} />
    </>
  );
};

UserCommentList.Comment = UserCommentCard;
